import { useEffect, useState } from 'react';
import { fetchReasonCodes } from '../models/paymentsV2Model';
let cache;
let pending;
let generation = 0;
export const resetPaymentReasonCodes = () => { generation += 1; cache = undefined; pending = undefined; };
export const loadPaymentReasonCodes = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    const current = generation;
    pending = fetchReasonCodes().then(result => { if (current === generation) cache = result; return result; }).finally(() => { if (current === generation) pending = undefined; });
  }
  return pending;
};
export function usePaymentReasonCodes() {
  const [codes, setCodes] = useState(cache || {});
  const [error, setError] = useState(null);
  useEffect(() => { let active = true; loadPaymentReasonCodes().then(result => { if (active) setCodes(result); }).catch(next => { if (active) setError(next); }); return () => { active = false; }; }, []);
  return { codesFor: action => codes[action] || [], error };
}
